module.exports = __webpack_public_path__ + "1a41ccd2f2f9857e53c09b75a2d9f1d4.png";